var _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle3, _circle4, _circle5, _rect7, _circle6, _path, _path2, _rect8, _path3, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAplicationSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 257,
    viewBox: "0 0 256 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128.5,
    r: 104,
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128.5,
    r: 88,
    stroke: "#D9D9DE",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 58.5,
    width: 200,
    height: 152,
    rx: 6,
    fill: "#EEEEF0",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 54.5,
    width: 208,
    height: 152,
    rx: 6,
    fill: "#EEEEF0",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 54.5,
    width: 216,
    height: 148,
    rx: 8,
    fill: "white",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 80.5,
    width: 124,
    height: 12,
    rx: 4,
    fill: "#EEEEF0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 102.5,
    width: 72,
    height: 12,
    rx: 4,
    fill: "#EEEEF0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 124.5,
    width: 72,
    height: 12,
    rx: 4,
    fill: "#EEEEF0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 65.5,
    r: 3,
    fill: "#D9D9DE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 65.5,
    r: 3,
    fill: "#D9D9DE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 65.5,
    r: 3,
    fill: "#D9D9DE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 81.5,
    width: 54,
    height: 54,
    rx: 3,
    fill: "#D9D9DE",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 108.5,
    r: 16,
    fill: "white",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 108.589L58.2987 111.368C58.5079 111.544 58.8254 111.544 59.0346 111.368L66 105.5",
    stroke: "#5E5E6B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134 152.5C134 150.291 135.791 148.5 138 148.5H220C222.209 148.5 224 150.291 224 152.5V201.5H134V152.5Z",
    fill: "#EEEEF0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 148.5,
    width: 90,
    height: 21,
    rx: 4,
    fill: "#EEEEF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 184.5C32 182.291 33.7909 180.5 36 180.5H118C120.209 180.5 122 182.291 122 184.5V201.5H32V184.5Z",
    fill: "#EEEEF0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 103.5,
    width: 40,
    height: 32,
    rx: 3,
    fill: "white",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 115,
    y: 109.5,
    width: 4,
    height: 20,
    rx: 2,
    fill: "#D9D9DE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 107,
    y: 109.5,
    width: 4,
    height: 20,
    rx: 2,
    fill: "#D9D9DE"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 115,
    y: 121.5,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#92929E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 123,
    y: 109.5,
    width: 4,
    height: 20,
    rx: 2,
    fill: "#D9D9DE"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 123,
    y: 115.5,
    width: 4,
    height: 14,
    rx: 2,
    fill: "#92929E"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 107,
    y: 117.5,
    width: 4,
    height: 12,
    rx: 2,
    fill: "#92929E"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 131,
    y: 109.5,
    width: 4,
    height: 20,
    rx: 2,
    fill: "#D9D9DE"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 131,
    y: 120.5,
    width: 4,
    height: 9,
    rx: 2,
    fill: "#92929E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.258 92.9178C213.384 90.7331 212.947 89.6407 213.176 88.948C213.375 88.3466 213.847 87.8749 214.448 87.6762C215.141 87.4474 216.233 87.8843 218.418 88.7582L233.153 94.6524C235.252 95.4918 236.301 95.9114 236.646 96.5411C236.945 97.0881 236.973 97.7435 236.719 98.3135C236.428 98.9696 235.417 99.475 233.396 100.486L229.41 102.479C229.056 102.656 228.879 102.744 228.726 102.862C228.589 102.967 228.467 103.089 228.363 103.225C228.244 103.379 228.156 103.556 227.979 103.91L225.986 107.896C224.975 109.917 224.47 110.928 223.814 111.219C223.244 111.473 222.588 111.445 222.041 111.146C221.412 110.801 220.992 109.752 220.152 107.653L214.258 92.9178Z",
    fill: "white",
    stroke: "#92929E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M233.406 107.906L239.063 113.562",
    stroke: "#92929E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M236.234 103.663L240.477 107.905",
    stroke: "#92929E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.163 110.734L231.992 113.562",
    stroke: "#92929E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAplicationSuccess);
export default __webpack_public_path__ + "static/media/aplication-success.fc602919c8a141a8d492ee32bc9bd339.svg";
export { ForwardRef as ReactComponent };